import React from 'react';
import Acord24Form from './Acord24Form';
import type { Acord24FormRef } from './Acord24Form';
import type { StoredCoverage, StoredPolicy } from '../../utils/parseAcord24StoredCoverages';

export type { Acord24FormRef };

interface Acord24With101FormProps {
  selectedPolicies?: string[];
  insuredId?: string;
  selectedLocationLabel?: string;
  editCoverages?: StoredCoverage[];
  editPolicies?: StoredPolicy[];
}

const Acord24With101Form = React.forwardRef<Acord24FormRef, Acord24With101FormProps>(
  function Acord24With101Form({ selectedPolicies = [], insuredId = '', selectedLocationLabel = '', editCoverages, editPolicies }, ref) {
    return <Acord24Form ref={ref} showAcord101 selectedPolicies={selectedPolicies} insuredId={insuredId} selectedLocationLabel={selectedLocationLabel} editCoverages={editCoverages} editPolicies={editPolicies} />;
  }
);

export default Acord24With101Form;
